(function ($, _, Drupal) {
  Drupal.behaviors.photoSlider = {
    attach: _.once(function (context) {
      $(".photo-slider__wrapper", context).each(function () {
        const $wrapper = $(this);
        const $content = $wrapper.find('.photo-slider__content');
        const $imageContainer = $wrapper.find('.photo-slider__images .swiper-container');
        const $prevBtn = $wrapper.find('.swiper-button-prev');
        const $nextBtn = $wrapper.find('.swiper-button-next');
        const carouselCount = parseInt($content.find('.carousel-count').text(), 10);
        const sliderLoop = carouselCount > 1;

        if (carouselCount <= 1) {
          $prevBtn.hide();
          $nextBtn.hide();
        }

        if ($imageContainer.length === 0) return;

        // IMAGE SLIDER (DESKTOP)
        const paragraphPhotoSlide = new Swiper($imageContainer[0], {
          slidesPerView: 1.10,
          slidesPerGroup: 1,
          spaceBetween: 0,
          freeMode: false,
          simulateTouch: false,
          allowTouchMove: false,
          mousewheel: false,
          speed: 500,
          loop: sliderLoop,
          effect: "creative",
          creativeEffect: {
            prev: {
              shadow: true,
              translate: ["-20%", 0, -1],
            },
            next: {
              translate: ["100%", 0, 0],
            },
          },
        });

        // VERTICAL SLIDER (DESKTOP)
        const verticalContainer = $content.find('.photo-slider-vertical');
        const paragraphVerticalSwiper = new Swiper(verticalContainer[0], {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          freeMode: false,
          simulateTouch: false,
          allowTouchMove: false,
          mousewheel: false,
          speed: 500,
          loop: sliderLoop,
          direction: 'vertical',
        });

        // MOBILE SLIDER
        const $mobileSwiper = $content.find('.photo-slider-mobile');
        const paragraphVerticalSwiperMobile = new Swiper($mobileSwiper[0], {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          freeMode: false,
          simulateTouch: true,
          speed: 300,
          effect: "creative",
          creativeEffect: {
            prev: {
              shadow: true,
              translate: ["-20%", 0, -1],
            },
            next: {
              translate: ["100%", 0, 0],
            },
          },
          navigation: {
            nextEl: $nextBtn[0],
            prevEl: $prevBtn[0],
          },
        });

        // DISABLE SCROLL SLIDE
        if (window.innerWidth >= 1180) {
          $wrapper.on('wheel DOMMouseScroll mousewheel', function (e) {
            e.stopImmediatePropagation();
          });
        }

        // DESKTOP ARROW CONTROL (FIX)
        $nextBtn.on('click', function () {
          if (window.innerWidth >= 1180 && $(this).hasClass('swiper-button-disabled')) return;
          if (window.innerWidth >= 1180) {
            paragraphPhotoSlide.slideNext();
            paragraphVerticalSwiper.slideNext();
          }
        });

        $prevBtn.on('click', function () {
          if (window.innerWidth >= 1180 && $(this).hasClass('swiper-button-disabled')) return;
          if (window.innerWidth >= 1180) {
            paragraphPhotoSlide.slidePrev();
            paragraphVerticalSwiper.slidePrev();
          }
        });

        function updateArrows(swiper) {

          if (window.innerWidth < 1180) return;

          const realIndex = swiper.realIndex;
          const totalSlides = swiper.slides.length - swiper.loopedSlides * 2;

          if (realIndex === 0) {
            $prevBtn.addClass('swiper-button-disabled');
          } else {
            $prevBtn.removeClass('swiper-button-disabled');
          }

          if (realIndex === totalSlides - 1) {
            $nextBtn.addClass('swiper-button-disabled');
          } else {
            $nextBtn.removeClass('swiper-button-disabled');
          }
        }

        if (window.innerWidth >= 1180) {
          updateArrows(paragraphPhotoSlide);
        }

        paragraphPhotoSlide.on('slideChange', function () {
          if (window.innerWidth >= 1180) {
            updateArrows(paragraphPhotoSlide);
          }
        });

        // Keyboard accessibility
        $wrapper.keyup(function (event) {
          if (event.keyCode === 13 && window.innerWidth >= 1180 && sliderLoop) {
            paragraphPhotoSlide.slideNext();
            paragraphVerticalSwiper.slideNext();
          }
        });

        // Handle resizing
        let resizeId;
        $(window).on('resize.photoSlider-' + $wrapper.index(), function () {
          clearTimeout(resizeId);
          resizeId = setTimeout(() => {
            paragraphPhotoSlide.update();
            paragraphVerticalSwiper.update();
            paragraphVerticalSwiperMobile.update();
          }, 100);
        });
      });
    })
  };
})(jQuery, _, Drupal);
